import type { Notification } from '@/types/notification.types';
import { dashboardRoutePaths } from '@/routes/route-config';

/**
 * Where a "you were mentioned" notice opens: the note the name was written
 * in. The visit opens on its Notes tab; a procedure needs its visit's id,
 * which the notice carries in its params.
 */
export function mentionPath(
  n: Pick<Notification, 'resourceType' | 'resourceId' | 'i18n'>,
): string | null {
  if (!n.resourceId) return null;
  switch (n.resourceType) {
    case 'reservation':
      return `${dashboardRoutePaths.reservationDetails.replace(
        ':appointmentId',
        n.resourceId,
      )}?tab=notes`;
    case 'treatment_item': {
      const appointmentId = n.i18n?.params?.appointmentId;
      return typeof appointmentId === 'string' && appointmentId
        ? dashboardRoutePaths.procedureDetails
            .replace(':appointmentId', appointmentId)
            .replace(':procedureId', n.resourceId)
        : null;
    }
    case 'lab_request':
      return dashboardRoutePaths.labRequestDetails.replace(
        ':labRequestId',
        n.resourceId,
      );
    default:
      return null;
  }
}
